// Dubai - freelance personal trainer. Client-facing; no trainer list.
const content = {
    slug: 'freelance-personal-trainer',
    title: 'Freelance Personal Trainer in Dubai | vs Gym Trainers',
    description: (c) =>
        `Hiring a freelance personal trainer in Dubai: how it compares with gym PT, what to check, and what it costs. Packages from ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Dubai · Freelance trainer',
    h1: 'Freelance Personal Trainer in Dubai',
    lead: 'A freelance trainer comes to you - your apartment, building gym or the beach - instead of tying you to one gym\'s floor and membership. Here is how freelance and gym trainers compare, and what to check before you hire.',
    image: 'personal-trainer/personal-trainer-png.png',
    imageAlt: 'Freelance personal trainer ready for a home session',
    facts: ['Trains where you are', 'No gym membership needed', 'Checked registration'],
    matchSummary: 'a freelance personal trainer in Dubai',
    trainerCta: true,
    packagesTitle: 'Freelance trainer packages',
    sections: [
        {
            title: 'Freelance vs gym trainer',
            cards: [
                { title: 'Location', body: 'Freelance: anywhere - home, building gym, park. Gym trainer: only that gym, usually with a membership.' },
                { title: 'Schedule', body: 'Freelance trainers fit around your day, including early mornings before work.' },
                { title: 'Cost', body: 'No membership on top. You pay for sessions only, often less per session than big-brand gym PT.' },
                { title: 'Equipment', body: 'Gyms have more machines; freelance trainers bring portable kit and use your building gym.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'What to check before hiring a freelance trainer in Dubai',
            tone: 'muted',
            items: [
                'A recognised fitness certification, and registration with REPs UAE, the national register for exercise professionals.',
                'The permit or licence needed to work freelance in the UAE.',
                'First aid and CPR training.',
                'Clear package terms: what happens if you cancel, travel, or want to change trainer.',
            ],
        },
        {
            title: 'How StringsSG works with freelance trainers',
            paragraphs: [
                'We check certifications and registration before a trainer joins, set fixed package prices so you are not negotiating, and handle scheduling and payment. If the fit is not right, we match you with someone else. You get the flexibility of a freelance trainer without the risk of hiring a stranger from a classifieds post.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Is it legal to hire a freelance personal trainer in Dubai?',
            answer: 'Yes, when the trainer holds the right registration and freelance permit or licence. Ask to see them - our trainers are checked before they join.',
        },
        {
            question: 'How much does a freelance personal trainer cost in Dubai?',
            answer: (c) => `With StringsSG, from ${c.money(c.lowest, 0)} to ${c.money(c.pt('Elite', 14), 0)} a session depending on package and trainer level.`,
        },
        {
            question: 'I am a trainer - can I join?',
            answer: 'Yes. We are building our founding team in Dubai; apply using the link at the bottom of this page.',
        },
    ],
    schema: { name: 'Freelance Personal Trainer in Dubai' },
}

export default content
